import { Story } from '../../DocTypes';

export const imageStory: Story = {
  title: 'Image',
  description: 'List with items with an image',
  coreComponent: {
    html: `<tag-list
  image-field='image'
  image-height='40px'
  image-width='40px'
  image-border-radius='50%'
  image-object-fit='cover'
  primary-field='name'>
    </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Jordan Norry',
      },
      {
        image:
          'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Sarah Young',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
      },
      {
        image:
          'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
        name: 'Derek Been',
      },
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
  imageField='image'
  imageHeight='40px'
  imageWidth='40px'
  imageBorderRadius='50%'
  imageObjectFit='cover'
  primaryField='name'
  data={[
  {
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
    name: 'Jordan Norry',
  },
  {
    image:
      'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
    name: 'Sarah Young',
  },
  {
    image:
      'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
    name: 'Susan Warmly',
  },
  {
    image:
      'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    name: 'Derek Been',
  },
  ]}
  />`,
  },
};
